import script from "./BaseHeaderMain.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseHeaderMain.vue?vue&type=script&lang=ts&setup=true"

import "./BaseHeaderMain.vue?vue&type=style&index=0&id=9adb8698&lang=scss"

const __exports__ = script;

export default __exports__